"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _dates = require("MeetingsBase/constants/dates");

var _default = (0, _immutable.Record)({
  duration: _dates.FIFTEEN_MINUTE_DURATION,
  formFields: null,
  dateString: null,
  dateTime: null
}, 'Event');

exports.default = _default;
module.exports = exports.default;